import { InvoiceListRowsSkeleton } from "../loading/SkeletonBlocks.jsx";
import { formatBillingInstant } from "../../lib/stripeInstant.js";

function formatAmount(amountPaid, currency) {
  return (amountPaid / 100).toLocaleString("en-CA", {
    style: "currency",
    currency: currency.toUpperCase(),
  });
}

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export default function InvoiceHistoryList({
  invoices,
  isLoading,
  className = "",
  title = "Invoice history",
  subtitle = "",
}) {
  return (
    <section
      className={`overflow-hidden rounded-2xl border border-hc-surface-border bg-hc-surface ${className}`}
    >
      <div className="border-b border-hc-surface-border px-5 py-3.5">
        <h2 className="text-sm font-semibold tracking-[-0.15px] text-hc-text">{title}</h2>
        {subtitle ? <p className="mt-0.5 text-xs text-hc-text-dim">{subtitle}</p> : null}
      </div>

      {isLoading ? (
        <InvoiceListRowsSkeleton rows={3} />
      ) : invoices.length === 0 ? (
        <p className="px-5 py-6 text-xs text-hc-text-dim">No invoices yet.</p>
      ) : (
        <ul className="divide-y divide-hc-surface-border/80">
          {invoices.map((inv) => (
            <li
              key={inv.id}
              className="flex flex-wrap items-center justify-between gap-3 px-5 py-4"
            >
              <div className="flex min-w-0 items-center gap-3">
                <span
                  className={`shrink-0 rounded-full border px-2 py-0.5 text-xs font-medium ${inv.status === "paid"
                    ? "border-hc-success/35 bg-hc-success-muted text-hc-success"
                    : "border-hc-warning/35 bg-hc-warning-muted text-hc-warning"
                    }`}
                >
                  {formatStatus(inv.status || "open")}
                </span>
                <div>
                  <p className="text-sm tracking-[-0.15px] text-hc-text">
                    {inv.number || inv.id}
                  </p>
                  <p className="text-xs text-hc-text-dim">
                    {formatBillingInstant(inv.created) || "—"}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-sm font-semibold tracking-[-0.15px] text-hc-text">
                  {formatAmount(inv.amount_paid, inv.currency)}
                </span>
                {inv.invoice_pdf ? (
                  <a
                    href={inv.invoice_pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-hc-text-dim hover:text-hc-text transition"
                    aria-label={`Download ${inv.number || inv.id}`}
                  >
                    <i className="icon-document-download leading-none" aria-hidden="true" />
                  </a>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
